let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gP6jR")).then(() => parcelRequire('7N8D9'));